<div class="trip-wrapper">
    <div class="my-trips-container">
        <div class="my-trip">
            <div class="illustration-wrapper">
                <img class="illustration-img" src="assets/images/illustrations--Trips.svg" alt="My trip" width="360" height="270">
                <div class="description-wrapper">
                    <h3 class="title">No upcoming trips</h3>
                    <div class="content">
                        Plan your next trip with Saudia
                    </div>
                </div>
            </div>
            <button mat-button class="button--secondary-small"> Plan now </button>
        </div>
    </div>
</div>